import { defineComponent as _defineComponent } from 'vue'
import { ArticleEditMode } from '@/@types/ArticleEditMode';
import BotSettingsDialog from '@/components/layout/dialogs/BotSettingsDialog.vue';
import EventBus from '@/EventBus';
import { ARTICLE_CREATE, BOT_SETTINGS_UPDATED, COMPANY_CREATE, OPEN_BOT_SETTINGS } from '@/events';
import { Article } from '@/models/article/Article';
import { Company } from '@/models/Company';
import { Logger } from '@/other/Logger';
import * as routerNames from '@/routerNames';
import apiService from '@/services/ApiService';
import authService from '@/services/AuthService';
import notificationService from '@/services/NotificationService';
import store from '@/store';
import { commitSetArticleEditorArticle } from '@/store/commits/articleEditorCommits';
import { commitSetArticleMode } from '@/store/commits/sharedCommits';
import { commitSetUserCompanies } from '@/store/commits/userCommits';
import { computed, onBeforeMount, onBeforeUnmount, ref } from 'vue';
import ArticleCreateDialog from '@/components/layout/dialogs/ArticleCreateDialog.vue';
import CreateCompanyDialog from '@/components/layout/dialogs/CreateCompanyDialog.vue';
import WorkspaceCreateDialog from '@/components/layout/dialogs/WorkspaceCreateDialog.vue';
import { useRoute, useRouter } from 'vue-router/composables';
import { Meeting } from '@/@types/Meeting';


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogManager',
  setup(__props) {

const log = new Logger('DialogManager');

const router = useRouter();
const route = useRoute();

const isAuthorized = computed(() => store.state.user && authService.isAuthorized());

// Expose refs for parent component to access dialogs if needed
const createCompanyDialog = ref(null);
const articleCreateDialog = ref(null);
const botSettingsDialog = ref(null);

const loadUser = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    apiService
      .getUser()
      .then((res) => {
        authService.setUser(res.data.user);
        commitSetUserCompanies(res.data.companies.map((item) => Company.parse(item)));
        resolve();
      })
      .catch((err) => {
        apiService.handleResponseError(err);
        reject();
      });
  });
};

const handleCreateCompany = () => {
  createCompanyDialog.value
    .show()
    .then((company: Company) => {
      notificationService.success(`Company '${company.title}' successfully created`);
      loadUser()
        .then(null)
        .catch((res: any) => {
          apiService.handleResponseError(res);
        });
    })
    .catch((err: Error | string) => {
      if (!err) return;
      log.error(err);
    });
};

const handleCreateArticle = () => {
  const article = new Article();
  const lastWorkspace = store.state.workspace;

  if (lastWorkspace && lastWorkspace.id && lastWorkspace.canEditArticles()) {
    article.workspace = lastWorkspace.id;
  }
  const showDialog = () => {
    articleCreateDialog.value
      .show(article)
      .then(async (item: Article) => {
        if (item) {
          const routeParams = item.id ? { id: item.id } : {};
          await router.push({ name: routerNames.ARTICLE_CREATE, params: routeParams });
          if (routerNames.ARTICLE_CREATE === route.name) {
            commitSetArticleEditorArticle(item);
            commitSetArticleMode(ArticleEditMode.NOTES);
            store.commit('setCreateArticle', item);
          }
        }
      })
      .catch((error: any) => {
        apiService.handleResponseError(error);
      });
  };

  showDialog();
};

const handleOpenBotSettings = async (item?: Meeting) => {
  try {
    const updatedItemData = await botSettingsDialog.value.show(item);
    if (updatedItemData) EventBus.$emit(BOT_SETTINGS_UPDATED, updatedItemData);
  } catch (err) {
    if (!err) return;
    log.error(err);
  }
};

onBeforeMount(async () => {
  EventBus.$on(COMPANY_CREATE, handleCreateCompany);
  EventBus.$on(ARTICLE_CREATE, handleCreateArticle);
  EventBus.$on(OPEN_BOT_SETTINGS, handleOpenBotSettings);
});

onBeforeUnmount(() => {
  EventBus.$off(COMPANY_CREATE, handleCreateCompany);
  EventBus.$off(ARTICLE_CREATE);
  EventBus.$off(ARTICLE_CREATE, handleCreateArticle);
  EventBus.$off(OPEN_BOT_SETTINGS);
});

return { __sfc: true,log, router, route, isAuthorized, createCompanyDialog, articleCreateDialog, botSettingsDialog, loadUser, handleCreateCompany, handleCreateArticle, handleOpenBotSettings, BotSettingsDialog, ArticleCreateDialog, CreateCompanyDialog, WorkspaceCreateDialog }
}

})